import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Bootstrap
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// Stylesheet
import "../src/assets/Css/style.css";
import "font-awesome/css/font-awesome.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
